import { type ApolloError, useSubscription } from '@apollo/client'
import { useState } from 'react'

import { useUser } from '@/client/context/user'
import { USER_LIVE_HELP_REQUESTS_TO_JOIN_SUBSCRIPTION } from '@/client/services/hasura'
import type {
  UserLiveHelpRequestsToJoinSubscription,
  UserLiveHelpRequestsToJoinSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'

import { liveHelpRequestWithSessionAndPostFromFragment } from '../../transforms/detailsFromFragments'
import type { LiveHelpRequestWithSessionAndPost } from '../../types'

export default function useRealtimeUserLiveHelpRequestsToJoin(): {
  loading: boolean
  error: ApolloError | null
  liveHelpRequests: LiveHelpRequestWithSessionAndPost[]
} {
  const user = useUser()

  const [liveHelpRequests, setLiveHelpRequests] = useState<
    LiveHelpRequestWithSessionAndPost[] | null
  >(null)

  const { loading, error = null } = useSubscription<
    UserLiveHelpRequestsToJoinSubscription,
    UserLiveHelpRequestsToJoinSubscriptionVariables
  >(USER_LIVE_HELP_REQUESTS_TO_JOIN_SUBSCRIPTION, {
    variables: {
      sessionRegistrationUserId: user.id,
      currentUserId: user.id,
    },
    onData: data => {
      const liveHelpRequestFragments = data.data.data?.live_help_request ?? []

      setLiveHelpRequests(
        liveHelpRequestFragments.map(liveHelpRequestWithSessionAndPostFromFragment)
      )
    },
  })

  return {
    loading: loading && liveHelpRequests == null,
    error,
    liveHelpRequests: liveHelpRequests ?? [],
  }
}
